/**
 * Infinity Collectables – Header Pill Search (Predictive)
 * assets/ic-header-search.js
 *
 * Uses Shopify's Predictive Search API:
 * /search/suggest.json?q=...&resources[type]=product&resources[limit]=6
 */
(function () {
  'use strict';

  const form     = document.getElementById('ic-header-search-form');
  const input    = document.getElementById('ic-header-search-input');
  const results  = document.getElementById('ic-header-search-results');
  const clearBtn = document.getElementById('ic-header-search-clear');

  if (!form || !input || !results) return;

  let debounceTimer = null;
  let currentQuery  = '';
  let abortCtrl     = null;

  /* ── helpers ── */
  function money(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escHtml(str) {
    const d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  /* ── open / close ── */
  function openResults() {
    results.classList.add('is-open');
    input.setAttribute('aria-expanded', 'true');
  }
  function closeResults() {
    results.classList.remove('is-open');
    input.setAttribute('aria-expanded', 'false');
  }

  /* ── render ── */
  function renderProducts(products, query) {
    if (!products || products.length === 0) {
      results.innerHTML = `<p class="ic-search-results__empty">No results for "<em>${escHtml(query)}</em>"</p>`;
      openResults();
      return;
    }

    let html = '<p class="ic-search-results__heading">Products</p>';
    products.forEach(p => {
      const price  = p.price_min != null ? money(p.price_min) : '';
      const imgSrc = p.featured_image && p.featured_image.url
        ? p.featured_image.url.replace(/\?.*/, '') + '?width=88'
        : '';

      html += `
        <a href="${escHtml(p.url)}" class="ic-search-result-item" role="option">
          ${imgSrc
            ? `<img src="${escHtml(imgSrc)}" alt="${escHtml(p.featured_image.alt || p.title)}" class="ic-search-result-item__img" width="44" height="44" loading="lazy">`
            : `<div class="ic-search-result-item__img"></div>`}
          <span class="ic-search-result-item__info">
            <span class="ic-search-result-item__title">${escHtml(p.title)}</span>
            ${price ? `<span class="ic-search-result-item__price">${price}</span>` : ''}
          </span>
        </a>`;
    });

    html += `<div class="ic-search-results__footer">
      <a href="/search?type=product&q=${encodeURIComponent(query)}">
        View all results for "<strong>${escHtml(query)}</strong>" →
      </a>
    </div>`;

    results.innerHTML = html;
    openResults();
  }

  /* ── fetch ── */
  async function fetchSuggestions(q) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
      const resp = await fetch(url, { signal: abortCtrl.signal });
      if (!resp.ok) throw new Error('Search failed');
      const data = await resp.json();
      const products = data.resources && data.resources.results && data.resources.results.products;
      renderProducts(products, q);
    } catch (err) {
      if (err.name !== 'AbortError') {
        closeResults();
      }
    }
  }

  /* ── input handler ── */
  input.addEventListener('input', function () {
    const q = this.value.trim();
    currentQuery = q;

    clearBtn.classList.toggle('is-visible', q.length > 0);

    if (q.length < 2) {
      closeResults();
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchSuggestions(q);
    }, 280);
  });

  /* ── clear ── */
  clearBtn.addEventListener('click', function () {
    input.value = '';
    currentQuery = '';
    this.classList.remove('is-visible');
    closeResults();
    input.focus();
  });

  /* ── close on outside click ── */
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target) && !results.contains(e.target)) {
      closeResults();
    }
  });

  /* ── keyboard: Escape closes ── */
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeResults();
      this.blur();
    }
  });

  /* ── form submit: redirect to search ── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const q = input.value.trim();
    if (q) {
      window.location.href = `/search?type=product&q=${encodeURIComponent(q)}`;
    }
  });
})();
